import {useState, useEffect} from 'react'
import {pluck, add, reduce} from 'ramda'
import {Cost} from "./Cost"
import { useDisplay } from '../../context'

export const CostDisplay = ({team}) => {
    const [average, setAverage] = useState(0)
    const [year1, setYear1] = useState(0)
    const [year2, setYear2] = useState(0)
    const [year3, setYear3] = useState(0)
    const [total, setTotal] = useState(0)
    const currentYear = new Date().getFullYear()
    const {displayY1, displayY2, displayY3, displayAverage} = useDisplay()

    useEffect(() => {
        const year1s = pluck('year1', team)
        setYear1(reduce(add, 0, year1s))
        const year2s = pluck('year2', team)
        setYear2(reduce(add, 0, year2s))
        const year3s = pluck('year3', team)
        setYear3(reduce(add, 0, year3s))
        const totals = pluck('total', team)
        setTotal(reduce(add, 0, totals))
        const averages = pluck('average', team)
        setAverage(reduce(add, 0, averages))
    }, [team])
    return(
        <div style={{margin: "0 1rem .5rem 1rem"}}>
            {displayY1 && <Cost title={currentYear} cost={year1}/>}
            {displayY2 && <Cost title={currentYear + 1} cost={year2}/>}
            {displayY3 && <Cost title={currentYear + 2} cost={year3}/>}
            {(displayY1 || displayY2 || displayY3) && <div style={{borderTop: "1px solid lightgrey"}}/>}
            {displayAverage && <Cost title={"Average"} cost={average}/>}
            <Cost title={"Total"} cost={total}/>
        </div>
    )
}